import { useAuth0 } from "@auth0/auth0-react";
import React, { useEffect, useState } from "react";
import { PageLayout } from "../components/page-layout";
import {
  getFavorites,
  addFavorite,
  removeFavorite,
} from "../services/mongodb.service";
import { FavoriteListings } from "../components/favorite-listings";

export const FavoritesPage = () => {
  const { user, getAccessTokenSilently } = useAuth0();
  const [favorites, setFavorites] = useState([]);

  useEffect(() => {
    if (!user?.sub) {
      return;
    }
    // Call getAccessTokenSilently to get the access token
    getAccessTokenSilently().then((accessToken) => {
      // Pass the access token to getFavorites
      getFavorites(user.sub, accessToken)
        .then((response) => {
          setFavorites(response.data.favorites);
          console.log("Favorites fetched:", response.data.favorites);
        })
        .catch((error) => {
          console.error("Error fetching favorites:", error);
        });
    });
  }, [getAccessTokenSilently, user?.sub]);

  const onAddToFavorites = (item) => {
    getAccessTokenSilently().then((accessToken) => {
      setFavorites((prevFavorites) => {
        const sub = user.sub;

        const isAlreadyFavorited = prevFavorites.some(
          (favItem) => favItem.id === item.id
        );

        if (isAlreadyFavorited) {
          // If the item is already favorited, remove it from the favorites
          const newFavorites = prevFavorites.filter(
            (favItem) => favItem.id !== item.id
          );
          console.log("removeFavorite", sub, item.title);
          // Send a DELETE request to remove the item from the database
          removeFavorite(sub, item.id, accessToken);

          return newFavorites;
        } else {
          // If the item is not favorited, add it to the favorites
          const newFavorites = [...prevFavorites, item];

          // Send a POST request to add the item to the database
          addFavorite(sub, item, accessToken);
          console.log("addFavorite", sub, item.title);
          return newFavorites;
        }
      });
    });
  };

  return (
    <PageLayout>
      <div className="content-layout">
        <FavoriteListings
          listings={favorites}
          onAddToFavorites={onAddToFavorites}
        />{" "}
      </div>
    </PageLayout>
  );
};
